import config from '../config';
import { ActionTypes as actions, PracticeActions, ConsultationsActions, UserActions, ToastActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import { NotificationsUtils } from '../utils';
import { toast } from 'react-toastify';
import io from 'socket.io-client';
import axios from 'axios';

const createInstantSessionAndSendInvite = (token, client_phone, client_name, successAction, errorAction) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/VEG/instant_session`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    var requestObject = {
      client_phone: client_phone
    }

    if (client_name) {
      requestObject.client_name = client_name;
    }

    axios.post(requestURL, requestObject, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
        if (successAction) {
          successAction();
        }
        dispatch(ToastActions.displayInfo('Invite Sent!'))
      }
      if (data.error) {
        console.log(data.error)
        if (errorAction) {
          errorAction(data.error);
        }
      }
    }).catch((error) => {
      console.log(error)
      if (errorAction) {
        errorAction(error);
      }
    });

  }
}

const getAllInstantSessions = (token) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/VEG/instant_sessions/["INVITED", "WAITING", "IN_PROGRESS", "COMPLETED", "LEFT", "CANCELLED"]`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
        var allSessions  = data.instantSessions || [];
        var sessionsDict = {};

        allSessions.forEach((instantSesh) => {
          sessionsDict[instantSesh._id] = instantSesh;
        })

        dispatch({
          type: actions.EMG_INSTANT_SESSIONS_UPDATE,
          payload: sessionsDict,
        })

        dispatch(sortSessionDict());
      }

    }).catch((error) => { console.log(error) })

  }
}

const cancelInvite = (token, session) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/VEG/cancel_session/${session._id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
      }
    }).catch((error) => { console.log(error) })

  }
}

const updateSession = (instantSession) => {
  return (dispatch, getState) => {

    const state = getState();
    const allSessions = state.emg && state.emg.instantSessions ? state.emg.instantSessions : {};

    if (allSessions) {
      allSessions[instantSession._id] = instantSession;
      dispatch({
        type: actions.EMG_INSTANT_SESSIONS_UPDATE,
        payload: allSessions,
      })
      dispatch(sortSessionDict());
    }

  }
}

const endSessionComplete = (token, session) => {
  return (dispatch) => {

    let requestURL = `${config.BASE_URL}/VEG/update_instant_sessions/${session._id}/COMPLETED`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {
        let updatedSession = data.instantSession;
        dispatch(updateSession(updatedSession));
      }
    }).catch((error) => { console.log(error) })

  }
}

const sortSessionDict = () => {
  return (dispatch, getState) => {

    const state = getState();
    const allSessions = state.emg && state.emg.instantSessions ? state.emg.instantSessions : null;

    if (allSessions) {
      var sortedDict = {};
      var sessions = Object.keys(allSessions).map((session_id) => {
        return allSessions[session_id];
      }).sort((a, b) => { return new Date(b.updated_at) - new Date(a.updated_at) });
      sessions.forEach((sesh) => {
        const seshStatus = sesh.status;
        if (sortedDict[seshStatus]) {
          sortedDict[seshStatus].push(sesh);
        } else {
          sortedDict[seshStatus] = [sesh];
        }
      })
      dispatch({ type: actions.EMG_SESSIONS_STATUS_DICT_UPDATE, payload: sortedDict })
    }

  }
}

export default {
  cancelInvite,
  createInstantSessionAndSendInvite,
  endSessionComplete,
  getAllInstantSessions,
  updateSession,
}
